class PurchaseOptions extends HTMLElement {
  constructor() {
    super();
    this.productForm = this.closest('[data-main-product]')?.querySelector('product-form');
    this.productSelector = this.closest('[data-main-product]')?.querySelector('product-selector');
  }

  connectedCallback() {
    this.cards = this.querySelectorAll('.po__card');
    this.inputs = this.querySelectorAll('input[name="selling_plan"]');

    this.cards.forEach(card => {
      card.addEventListener('click', this.onCardClick.bind(this));
    });

    this.inputs.forEach(input => {
      input.addEventListener('change', this.onChange.bind(this));
    });

    this.syncState(true);
  }

  onCardClick(event) {
    if (event.target.closest('a')) return;
    const card = event.currentTarget;
    const input = card.querySelector('input[name="selling_plan"]');
    if (input && !input.checked) {
      input.checked = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  onChange(event) {
    this.classList.remove('has-error');
    this.syncState();
    this.updateProductSelector(event.target.value);
  }

  syncState(isInit) {
    const selected = this.querySelector('input[name="selling_plan"]:checked');
    const hasSellingPlan = !!(selected && selected.value);

    this.cards.forEach(card => {
      const input = card.querySelector('input[name="selling_plan"]');
      card.classList.toggle('is-active', input?.checked === true);
    });

    if (this.productForm) {
      if (hasSellingPlan) {
        this.productForm.setAttribute('data-has-selling-plan', 'true');
      } else {
        this.productForm.removeAttribute('data-has-selling-plan');
      }
      if (!isInit) this.productForm.toggleAddButton(false, '');
    }
  }

  updateProductSelector(sellingPlanId) {
    if (!this.productSelector) return;
    if (typeof this.productSelector.updateURL === 'function') {
      this.productSelector.updateURL(sellingPlanId || null);
    }
    if (typeof this.productSelector.renderProductInfo === 'function') {
      this.productSelector.renderProductInfo();
    }
  }

  isOneTimePurchase() {
    const selected = this.querySelector('input[name="selling_plan"]:checked');
    return !selected || !selected.value;
  }

  showError() {
    this.classList.add('has-error');
  }
}

if (!customElements.get('purchase-options')) {
  customElements.define('purchase-options', PurchaseOptions);
}
